import { translate } from "app/filters/i18nFilter";
import { abbrNumberWithPrefixFilter } from "app/filters/ngFilters";
import { FormFieldLabel, RangeSelectWithFilter } from "app/pages/sales-intelligence/common-components/form-fields";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { StyledAppsPriceFilterContent } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsPriceFilter/styles";
import { StyledFilterContentContainer } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/styles";
import { DOLLAR_PREFIX, RANGE_SELECT_WIDTH } from "app/pages/sales-intelligence/modules/find-apps-filters/constants";
import type FindAppsPriceFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/PriceFilter/PriceFilter";
import { AppsPriceType } from "app/pages/sales-intelligence/modules/find-apps-filters/types/commonEnums";

import PriceTypeFilter from "./components/PriceTypeFilter/PriceTypeFilter";

const formatNumber = abbrNumberWithPrefixFilter();

const PREFIX = `${DOLLAR_PREFIX} `;

type PriceValueType = number | undefined;

const AppsPriceFilter = ({ filter, value, onFilterUpdate }: IFilterViewBaseProps<FindAppsPriceFilter>) => {
    const handleTypeChange = (type?: AppsPriceType) => {
        if (!type) {
            return onFilterUpdate();
        }

        onFilterUpdate({ type });
    };

    const handlePriceChange = ([minValue, maxValue]: PriceValueType[]) => {
        onFilterUpdate({
            type: AppsPriceType.Paid,
            priceRange: {
                from: minValue,
                to: maxValue,
            },
        });
    };

    const formatDisplayedValue = (v: number): string => formatNumber(v, PREFIX);

    const range =
        value?.type !== AppsPriceType.Paid ? null : (
            <FormFieldLabel text={translate("si.find_apps.filters.price.range.label")}>
                <RangeSelectWithFilter
                    fieldName="price"
                    value={[value?.priceRange?.from, value?.priceRange?.to]}
                    optionsMin={filter.minOptions}
                    optionsMax={filter.maxOptions}
                    placeholderMin={translate("si.find_apps.filters.range.min.placeholder")}
                    placeholderMax={translate("si.find_apps.filters.range.max.placeholder")}
                    formatValue={formatDisplayedValue}
                    onChange={handlePriceChange}
                    width={RANGE_SELECT_WIDTH}
                />
            </FormFieldLabel>
        );

    return (
        <StyledAppsPriceFilterContent>
            <StyledFilterContentContainer>
                <PriceTypeFilter
                    value={value?.type as AppsPriceType}
                    options={filter.options.priceTypes}
                    onChange={handleTypeChange}
                />

                {range}
            </StyledFilterContentContainer>
        </StyledAppsPriceFilterContent>
    );
};

export default AppsPriceFilter;
